import { inject, Injectable } from '@angular/core';
import { Group } from '../../../models/group.model';
import { MediaContext } from '../../../models/media-context.model';
import { ConfirmHandler } from '../../dialog/dialog.model';
import { DialogService } from '../../dialog/dialog.service';
import { MoveToFolderDialogComponent } from '../move-to-folder-dialog.component';

export type MoveToFolderDialogConfig =
  | {
      title?: string;
      type: 'file';
      currentFolderId: string | null;
      context?: MediaContext;
    }
  | {
      title?: string;
      type: 'folder';
      sourceIds: string[];
      currentFolderId: string | null;
      context?: MediaContext;
    };

export interface MoveToFolderDialogData {
  title?: string;
  type: 'file' | 'folder';
  sourceIds: string[];
  currentFolderId: string | null;
  context?: MediaContext;
  onConfirm: ConfirmHandler<Group>;
}

@Injectable({
  providedIn: 'root',
})
export class MoveToFolderDialogService {
  private readonly _dialog = inject(DialogService);

  open(callback: ConfirmHandler<Group>, options: MoveToFolderDialogConfig) {
    const sourceIds = options.type === 'folder' ? options.sourceIds : [];

    return this._dialog.open<MoveToFolderDialogComponent, MoveToFolderDialogData>(
      MoveToFolderDialogComponent,
      {
        title: options.title,
        type: options.type,
        sourceIds,
        currentFolderId: options.currentFolderId,
        context: options.context,
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
